import { Component } from 'react';
import { Button, Row, Col, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';

import CustomDatePicker from './DatePickr';
import withRouter from '../../../util/WithRouter';
import Constants from '../../../util/Constants';
import DailySalesReportPage from './DailySalesReportPage';
import Util from '../../../util/Util';

class DailySalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      dateCondition: '',
      dateFrom: '',
      dateTo: '',
      alert: false,
      filteredOptions: [],
      showReport: false,
      reportParams: null,
      reportKey: 0,
    };
  }

  componentDidMount() {
    const options = reactLocalStorage.getObject(Constants.Model).user.options;
    const loggedInUser = reactLocalStorage.getObject(Constants.LoggedInUser);
    const loggedInUserId = loggedInUser.user_id;
    const loggedInUserRole = loggedInUser.role;

    // Filter options for active statuses
    const activeOptions = options.filter(
      (option) => option.status === Constants.Active || option.status === Constants.AlwaysActive
    );

    let filteredOptions;
    if (loggedInUserRole === "ADMIN") {
      // If the user is an admin, show all options
      filteredOptions = activeOptions;
    } else {
      // Otherwise, show the logged-in user and their reporting persons
      filteredOptions = activeOptions.filter(
        (option) => option.reporting === loggedInUserId || option.value === loggedInUserId
      );
    }

    // Find the logged-in user in the options
    const loggedInUserOption = activeOptions.find((option) => option.value === loggedInUserId);

    this.setState({
      selectedOptions: loggedInUserOption ? [loggedInUserOption] : [],
      filteredOptions,
    });
  }

  handleSelectChange = (options) => {
    this.setState({ selectedOptions: options });
  };

  handleMenuOpen = () => {
    const { selectedOptions } = this.state;
    const options = reactLocalStorage.getObject(Constants.Model).user.options.filter(
      (option) => option.status === Constants.Active || option.status === Constants.AlwaysActive
    );
    const loggedInUser = reactLocalStorage.getObject(Constants.LoggedInUser);
    const loggedInUserRole = loggedInUser.role;
    let filteredOptions;
    if (loggedInUserRole === Constants.Admin) {
      // If the user is an admin, show all options
      filteredOptions = options;
    } else if (selectedOptions.length > 0) {
      // Show only the reporting persons for the selected users
      filteredOptions = options.filter((option) =>
        selectedOptions.some(() => option.reporting === loggedInUser.user_id)
      );
    } else {
      // Default to the logged-in user's options if no other user is selected
      const loggedInUserId = loggedInUser.user_id;
      filteredOptions = options.filter(
        (option) => option.reporting === loggedInUserId || option.value === loggedInUserId
      );
    }

    this.setState({ filteredOptions });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { selectedOptions, dateCondition, dateFrom, dateTo } = this.state;
    if (!dateFrom || !dateTo || selectedOptions.length === 0) {
      this.setState({ alert: true });
      return;
    }

    const selectedIds = selectedOptions.map((option) => option.value);
    this.setState({
      showReport: true,
      reportParams: {
        selectedIds,
        dateCondition,
        dateFrom,
        dateTo,
      },
      reportKey: this.state.reportKey + 1,
    });
  };

  onValueChange = (field_key, condition, value, model_key) => {
    const [dateFrom, dateTo] = value.split('~');
    this.setState({ dateCondition: condition, dateFrom, dateTo });
  };

  render() {
    const { filteredOptions, alert, selectedOptions, routeParams } = this.state;

    return (
      <>
        {alert && (
          <Alert key="danger" variant="danger" dismissible className="m-2 p-3" onClose={() => this.setState({ alert: false })}>
            +
          </Alert>
        )}
        <div
          className="px-4 py-3 m-4 shadow rounded-lg"
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            margin: '2rem auto'
          }}
        >
          <Row className="align-items-start">
            {/* Multi-select dropdown */}
            <Col md={5}>
              <div className="form-group mb-0">
                <label
                  htmlFor="formSelect"
                  style={{
                    fontWeight: '600',
                    color: '#495057',
                    marginBottom: '0.5rem'
                  }}
                >
                  Users
                </label>
                <Select
                  isMulti
                  options={filteredOptions}
                  value={selectedOptions}
                  onChange={this.handleSelectChange}
                  onMenuOpen={this.handleMenuOpen}
                  placeholder="Select Users..."
                  isOptionDisabled={() => selectedOptions.length >= 3}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '44px',
                      borderColor: '#ced4da',
                      '&:hover': {
                        borderColor: '#adb5bd'
                      }
                    })
                  }}
                />
              </div>
            </Col>

            {/* Custom Date Picker */}
            <Col md={5}>
              <CustomDatePicker
                onDateChange={(dateFrom) => {
                  const date = dateFrom.split('~').filter(Boolean);
                  this.onValueChange(
                    'enquiry_date',
                    'BETWEEN',
                    `${Util.dateToServerDateTime(date[0])}~${Util.dateToServerDateTime(date[1])}`
                  );
                }}
                label={true}
              />
            </Col>

            {/* Submit button */}
            <Col md={2}>
              <div style={{ marginTop: '28px' }}>
                <Button
                  variant="primary"
                  onClick={this.handleSubmit}
                  style={{
                    padding: '0.5rem 1.5rem',
                    fontWeight: '500',
                    width: '100%'
                  }}
                >
                  Generate Report
                </Button>
              </div>
            </Col>
          </Row>
        </div>


        {this.state.showReport && (
          <DailySalesReportPage
            key={this.state.reportKey}
            selectedIds={this.state.reportParams.selectedIds}
            dateCondition={this.state.reportParams.dateCondition}
            dateFrom={this.state.reportParams.dateFrom}
            dateTo={this.state.reportParams.dateTo}
          />
        )}
      </>
    );
  }
}

export default withRouter(DailySalesReport);
